export default __webpack_public_path__ + "static/media/promo-1.f39d32d2.png";